exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".category-button[data-v-00f7d53e] {\n  cursor: pointer;\n  color: #0966c3;\n}", ""]);

// exports
